import Chart from '../../components/graphs/modules/Chart.js'
import Widget from '../../components/graphs/modules/Widget'
import { db, auth } from '../../plugins/firebase'

const meterHasData = (data, graph , prop, compare) =>{
    return data ? 
            data[graph] ?
                data[graph].find((chart) => chart[prop]=== compare)
                : false
            : false
}

const state = {
    meters: {},
    collection: null
}

const getters = {
    getStatus: state => 
        meter => {
            if(!meter) return true
            return state.meters[meter].status
        },
    getGraphs: state => 
        meter => {
            if(!state.meters[meter]) return {}
            return state.meters[meter]
        },
    getChart: state =>
        (meter, chart) => {
            if(!state.meters[meter]) return []
            if(!state.meters[meter].charts) return []
            return state.meters[meter].charts.find( c => c.id == chart )
        }
}

const actions = {
    setCollectionDb({ commit, dispatch }){
        return new Promise(async (resolve, reject) =>{
            if(auth.currentUser){
                commit('UPDATE_COLLECTION', auth.currentUser.uid)
                await dispatch('fetchUserData')
                return resolve()
            }else{
                commit('UPDATE_COLLECTION')
                return resolve()
            }
        })
    },
    fetchUserData({ commit, state }){
        return new Promise(async (resolve, reject) => {
            try {
                let response = await db.collection(state.collection).get()
                commit( 'SET_CHARTS' ,response.docs.map( meter => {
                    return {
                        name: meter.id,
                        charts: meter.data().charts.map( chart =>
                            new Chart(chart)
                        )
                    } 
                }))
                return resolve()
            } catch (error) {
                console.log(error)
                return reject({ message: '¡Ops! Ocurrio un error' })
            }
        })
    },
    saveChanges({ state, commit }, meter){
        return new Promise(async (resolve, reject) => {
            try {
                await db.doc(`${state.collection}/${meter}`).set({
                    charts: state.meters[meter].charts.map( c => c.get())
                })
                commit('UPDATE_CHANGES_STATUS', { meter, status: false })
                resolve()
            } catch (error) {
                console.log(error)
                commit('UPDATE_CHANGES_STATUS', { meter, status: false })
                resolve()
            }
        })
    },
    newChart({ state, commit }, payload){
        return new Promise(async (resolve, reject) => {

            const { meter, new_chart } = payload
        
            const exists = meterHasData(state.meters[meter], 'charts' , 'name', new_chart.name)

            if(exists) return reject({ message: 'Este nombre ya existe'})

            const chart = new Chart(new_chart)

            commit('SET_CHART', { meter: meter, chart: chart })

            commit('UPDATE_CHANGES_STATUS', { meter, status: true })

            resolve( { message: 'Done' })

        })
        
    },
    updatedChart({ state, commit }, payload) {
        return new Promise(async (resolve, reject) => {
            
            const { updated_chart, meter } = payload

            const exists = meterHasData(state.meters[meter], 'charts' , 'id', updated_chart.id)
            
            if(!exists) return { message: 'Esta grafica no existe'}

            const index = state.meters[meter].charts.findIndex( c => c.id == updated_chart.id )
            
            const chart = new Chart(updated_chart)
            
            commit('SET_CHART', { index, chart, meter })

            commit('UPDATE_CHANGES_STATUS', { meter, status: true })

            resolve( { message: 'Done' })

        })
        
    },
    deleteChart({ state, commit }, payload) {
        const { deleted_chart, meter } = payload

        const exists = meterHasData(state.meters[meter], 'charts' , 'id', deleted_chart.id)

        if(exists){

            const index = state.meters[meter].charts.findIndex((chart) => chart.id === deleted_chart.id)
            if(index < 0) return { error: 'Esta grafica no existe'}

            commit('DELETE_CHART', { index })

            commit('UPDATE_CHANGES_STATUS', { meter, status: true })

        }else
            return { error: 'Esta grafica no existe'}
    },
    newWidget({ state, commit }, payload){
        return new Promise(async (resolve, reject) => {

            const { meter, new_widget } = payload
        
            const exists = meterHasData(state.meters[meter], 'graphs' , 'name', new_widget.name)

            if(exists) return reject({ message: 'Este nombre ya existe'})

            const widget = new Widget(new_widget)

            commit('SET_WIDGET', { meter, widget })

            commit('UPDATE_CHANGES_STATUS', { meter, status: true })

            resolve( { message: 'Done' })

        })
        
    }
}

const mutations = {
    SET_CHARTS(state, chart_data){
        chart_data.forEach( meter => 
            state.meters[meter.name] = {
                charts: meter.charts
            }
        ) 
    },
    SET_CHART(state, payload){
        const { index, chart, meter } = payload
        if (payload.index !== undefined){
            state.meters[meter].charts[index] = chart 
        }else{
            if(state.meters[meter] == undefined) state.meters[meter] = {}
            state.meters[meter].charts ?
                state.meters[meter].charts.push(chart):
                state.meters[meter].charts = [chart]
        }
    },
    DELETE_CHART(state, payload){
        const { index, meter } = payload
        if(index > -1 ) state.meters[meter].charts.splice(index, 1);
    },
    SET_WIDGET(state, payload){
        const { index, widget, meter } = payload
        if (payload.index !== undefined){
            state.meters[meter].widgets[index] = chart 
        }else{
            if(state.meters[meter] == undefined) state.meters[meter] = {}
            state.meters[meter].widgets ?
                state.meters[meter].widgets.push(widget):
                state.meters[meter].widgets = [widget]
        }
    },
    UPDATE_COLLECTION(state, user){
        user 
            ? state.collection = `users/${user}/graphs`
            : state.collection = null
    },
    UPDATE_CHANGES_STATUS(state, data){
        state.meters[data.meter].status = data.status
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}